import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useMatchAtLeastOneRole } from 'utils/hooks';
import { RoleNames } from 'utils/constants';

import SubscriptionTable from './SubscriptionTable';
import ExternalSubscription from './ExternalSubscription';
import SubscriptionDetails from './subscription-details/SubscriptionDetails';
import { ListContainer } from 'components';

const Subscriptions = () => {
    const userIsStandardServicer = useMatchAtLeastOneRole([RoleNames.SERVICER_STANDARD]);

    return (
        <ListContainer>
            <Routes>
                <Route path="details/:userId/:subscriptionId" element={<SubscriptionDetails />} />
                {!userIsStandardServicer && (
                    <Route path="create-external" element={<ExternalSubscription />} />
                )}
                <Route index element={<SubscriptionTable />} />
                <Route path="*" element={<Navigate to="/subscriptions" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default Subscriptions;
